import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  selectTitle: {
    id: 'donater.form.base_currency.select_title',
    defaultMessage: 'Select currency',
  },
  selectSubtitle: {
    id: 'donater.form.base_currency.select_subtitle',
    defaultMessage: 'We support {amount} {amount, plural, one {currency.} other {currencies. Choose your one.}}',
  },
})
